/**
 * The month a Finances card shows, with Prev / Next / This month. Shared by
 * "Running costs & break-even" and "Purchases & IVA paid" (G-121 S4) so the
 * two cards step through months the same way. "This month" is the Barcelona
 * month, the one the server counts in (G-126: it was the browser's own month,
 * while the Salary section above used UTC).
 */
import { businessToday } from "../../utils/businessDay";

/** "October" — the month alone (G-171: the quarter's months on the IVA cards). */
export function monthName(year: number, month1to12: number): string {
  return new Date(Date.UTC(year, month1to12 - 1, 1)).toLocaleString(undefined, {
    month: "long",
    timeZone: "UTC",
  });
}

export function monthLabel(year: number, month1to12: number): string {
  return new Date(Date.UTC(year, month1to12 - 1, 1)).toLocaleString(undefined, {
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  });
}

export function MonthNav({
  year,
  month,
  onChange,
  compact = false,
}: {
  year: number;
  month: number;
  onChange: (year: number, month: number) => void;
  /** Just ‹ Month › — no words, no "This month" (the manager's Hours card). */
  compact?: boolean;
}) {
  const shift = (delta: number) => {
    const d = new Date(Date.UTC(year, month - 1 + delta, 1));
    onChange(d.getUTCFullYear(), d.getUTCMonth() + 1);
  };
  if (compact) {
    return (
      <div className="hours-month-nav">
        <button
          type="button"
          className="button tinted hours-month-arrow"
          aria-label="Previous month"
          onClick={() => shift(-1)}
        >
          ‹
        </button>
        <span className="hours-month-label">{monthLabel(year, month)}</span>
        <button
          type="button"
          className="button tinted hours-month-arrow"
          aria-label="Next month"
          onClick={() => shift(1)}
        >
          ›
        </button>
      </div>
    );
  }
  return (
    <div className="schedule-month-nav opcost-month-nav">
      <button type="button" className="button tinted" onClick={() => shift(-1)}>
        ‹ Prev
      </button>
      <span className="schedule-month-label">{monthLabel(year, month)}</span>
      <button type="button" className="button tinted" onClick={() => shift(1)}>
        Next ›
      </button>
      <button
        type="button"
        className="button plain"
        onClick={() => {
          const t = businessToday();
          onChange(t.year, t.month);
        }}
      >
        This month
      </button>
    </div>
  );
}
